<script setup lang="ts">
import { getAdyenPaymentAmount } from '~/lib/vendors/adyen/getAdyenPaymentAmount'
import '@adyen/adyen-web/styles/adyen.css'

const cartStore = useCartStore()
const storefrontStore = useStorefrontStore()
const { currency } = storeToRefs(storefrontStore)
const context = useNuxtApp()
const { locale, countryCode } = storefrontStore.currentMarket
const adyenSupportFunctions = useAdyenSupportFunctions()
const languageCode = adyenSupportFunctions.getAdyenLanguage(locale.html)

const applePayCompatible = window.ApplePaySession
const amount = computed(() =>
  getAdyenPaymentAmount({ priceTotal: Math.round(cartStore.cartSummary.priceTotal * 10000) / 100, currency: currency.value.code }),
)

const expressErrorArray = ref<string[]>([''])
const paymentMethodsResponse = await context.$payments.getPaymentMethods({ countryCode, languageCode, channel: 'Web', amount: amount.value })

</script>

<template>
  <div id="component-container">
    <CheckoutAdyenExpressPayment
      v-model="expressErrorArray"
      :is-apple-pay="false"
      :amount="amount"
      :payment-methods-response="paymentMethodsResponse"
    />
    <CheckoutAdyenExpressPayment
      v-if="applePayCompatible"
      v-model="expressErrorArray"
      :is-apple-pay="true"
      :amount="amount"
      :payment-methods-response="paymentMethodsResponse"
    />
  </div>
  <p
    v-if="expressErrorArray"
    class="red"
    v-html="expressErrorArray.join('<br/>')"
  />
</template>

<style lang="scss" scoped>
.red {
  color: var(--red);
  margin: 1.6rem;
}
#component-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1.6rem;
}
@media screen and (min-width:768px) {
  #component-container {
  margin-inline: 0rem;
  }
  .red {
  margin-inline: 0rem;
  }
}
</style>
